const APIS = {
  TICKET: "/helpdeskservice/api/ticket/",
  SUBJECT: "/helpdeskservice/api/queue/",
  PRIORITY: "/helpdeskservice/api/priority/",
  NOTICE: "/alertpopupservice/api/notice/",
  USER: "/usermanagementservice/api/user/",
  BRANCH: "/logisticservice/api/branch/",
  COMMENT: "/commentservice/api/comment/",
  STAFF: "/logisticservice/api/staff/",
  MERCHANT: "logisticservice/api/merchant/",
  FILE_HANDLER: "/driveservice/api/file/",
};

export default APIS;
